import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { ZoneModule } from '../zone/zone.module';



@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    SharedModule,
    DashboardRoutingModule,
    ZoneModule
  ]
})
export class DashboardModule { }
